import { render, staticRenderFns } from "./actInfoPage.vue?vue&type=template&id=542f7ceb"
import script from "./actInfoPage.vue?vue&type=script&lang=js"
export * from "./actInfoPage.vue?vue&type=script&lang=js"
import style0 from "./actInfoPage.vue?vue&type=style&index=0&id=542f7ceb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports